(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              setTimeout(() => {
                const sliderElement = this.querySelector('.new-carusel__slider');
                if (sliderElement) {
                  const flickityOptions = {
                        freeScroll:false,
                        cellAlign:'left',
                        contain: true,
                        wrapAround:true,
                        draggable: true,
                        pageDots:false,
                        groupCells: '100%',
                        on: {
                          ready: function() {
                              let product_card_labels = document.querySelectorAll('.product-card-labels');
                              product_card_labels.forEach((element) => {
                                  element.removeAttribute('style');
                              });
                          },
                          change: function( index ) {
                              let product_card_labels = document.querySelectorAll('.product-card-labels');
                              product_card_labels.forEach((element) => {
                                  element.removeAttribute('style');
                              });
                          }
                        }
                  };
                  const flickitySlider = new Flickity(sliderElement, flickityOptions);
                }
              }, 0);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
